import React from "react";

/**
 * props:
 * - images: [{id, src, title, date}]
 * - activeId
 * - onSelect(id)
 */
const ThumbnailList = ({
  images = [],
  mode,
  activeId,
  origid,
  onSelect = () => {},
}) => {
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const thumbpath = ["sdeck", "recce"].includes(mode) ? "recce" : "photo";

  const clickPath = (img) => {
    if (["sdeck", "recce"].includes(mode)) {
      return `${process.env.PUBLIC_URL}/photoshoot-recce/${img.photoshoot_id}/${mode}/${img.fname}`;
    } else {
      return `${process.env.PUBLIC_URL}/photographer-view-feedback/${img.photoshoot_id}/${img.orig_photo_id ? img.orig_photo_id : origid}/${img.fname}`;
    }
  };

  return (
    <div className="thumb-list" aria-label="Image thumbnails">
      {images.map((img) => (
        <div
          key={img.id}
          role="button"
          tabIndex={0}
          data-id={img.id}
          /* onClick={() => onSelect(img.id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onSelect(img.id);
            }
          }} */
          className={`thumb-item ${activeId === img.id ? "bg-blue-200" : "bg-gray-100"}`}
        >
          <a href={clickPath(img)}>
            <img
              className="thumb-img"
              src={`${process.env.REACT_APP_API_URL}/photoshoot/${thumbpath}/thumb/${img.fname}`}
              alt={img.title}
            />
            <div className="thumb-meta">
              <div className="thumb-date">{formatDate(img.created_at)}</div>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export default ThumbnailList;
